import * as gfunctions from './generalFunctions';

CCL.saveForLaterObj = {
  autoload: [
    ['saveForLater', $('.btn-save-for-later').length > 0],
    ['loadSaveForLaterCartSection', $('#saveForLaterCartSection').length > 0]
  ],

  saveForLater() {
    $('.c-cart').on('click', '.btn-save-for-later', (event) => {
      const presalesid = $(event.target).data('presalesid');
      if (presalesid) {
        const getProductDiv = `.card-${presalesid}`;
        $(getProductDiv).css('display', 'none');
      }
      const productId = $(event.target).data('productid');
      /* eslint-disable */
      ga('send', 'event', 'Save For later', 'Add to save for later', productId, 1);
      /* eslint-enable */
      this.saveForLaterAjax(event);
    });
  },

  saveForLaterAjax(event) {
    gfunctions.showLoader();
    const productId = $(event.target).data('productid');
    const token = $('#csrfSessionToken').data('csrf');
    const spaResHoldId = $(event.target).data('sparesholdid');
    const presalesid = $(event.target).data('presalesid');
    const dataObj = {
      productId
    };
    if (spaResHoldId) {
      dataObj.spaResHoldId = spaResHoldId;
    }
    if (presalesid) {
      dataObj.preSalesId = presalesid.toString();
    }

    $.ajax({
      type: 'POST',
      url: '/shop/cart/entry/execute-action/SAVEFORLATER',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: JSON.stringify(dataObj)
    }).done((response) => {
      // Check cruise cash 500 limit on cart
      if ($(event.target).parents('.c-cart-card').find('.cruise-cash-qty-increment-btn').length) {
        CCL.cartCard.cartCruiseCashRestrictUser();
      }
      // SAS Event for remove
      gfunctions.sasEvents('send', response.saveForLaterSasJsonData);
      gfunctions.hideLoader();
      if (presalesid) {
        this.updateCartAfterSave(response, presalesid);
      } else if (spaResHoldId) {
        this.updateCartAfterSave(response, spaResHoldId);
      } else {
        this.updateCartAfterSave(response, productId);
      }
      // Update save for later section everytime
      this.loadSaveForLaterCartSection();

      $('.cart-entries').find('.c-cart-card').each((index, element) => {
        if ($(element).find('.cancelEditGuest_ShoreEx').length) {
          $(element).find('.cancelEditGuest_ShoreEx').trigger('click');
        }
      });

      // update cart carousel
      if ($('body').find('.cart-carousel').length) {
        CCL.cartCard.updateCartCarousel();
      }

      // Update All products again once one product is removed
      // CCL.editCartStateroom.createStateroomHtml();
      console.log('save for later success');
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('save for later error');
    });
  },

  updateCartAfterSave(response, id) {
    if (response.wishList2Entries.length) {
      const { orderSummary } = response;
      const recentAdded = response.wishList2Entries.filter(x => x.productCode.toString() === id.toString());
      if (recentAdded.length) {
        $(`.card-${id}`).empty();
        $(`.card-${id}`).css('min-height', '100px');
        $(`.card-${id}`).html(`<a href="${recentAdded[0].productURL}">${recentAdded[0].productName}</a> has been moved to save for later section below.`);
      }

      gfunctions.updateHeaderCartWidget(response);
      gfunctions.updateCartSummary(orderSummary);
      gfunctions.updateProductSummary(orderSummary);
      if (response.cartEmpty) {
        window.location.reload();
      }
    }

    if (response.couponDetails) {
      gfunctions.updateCouponSummary(response);
    } else {
      $('.promo-code').show();
      $('.apply-promo').removeClass('show');
      $('.apply-promo-container').hide();
      $('.another-promo').hide();
      $('.apply-promo-container .error-msg').hide();
      $('.promo-added').hide();
    }
  },

  loadSaveForLaterCartSection() {
    const token = $('#csrfSessionToken').data('csrf');
    $.ajax({
      type: 'GET',
      url: '/shop/view/CCLSaveForLaterComponentController?componentUid=cclSaveForLaterComponent',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      // update save for later section
      $('#saveForLaterCartSection').empty();
      $('#saveForLaterCartSection').html(response);

      // Call other ajax functions for click events to work
      CCL.editCartStateroom.createStateroomHtml();
      CCL.cartCard.shoreExLoadWishlist();
    }).fail(() => {
      console.log('save for later section loading error');
    });
  }
};



// WEBPACK FOOTER //
// ./src/js/save-for-later.js